// @flow

// eslint-disable-next-line import/prefer-default-export
export const TYPES = {
  DESKTOP: "desktop",
  TABLET: "tablet",
  MOBILE: "mobile",
}

export const SMALL_MOBILE_SIZE = 560

export type WindowType = $Values<typeof TYPES>
